import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-05/lesson-12/task-02";

const task: Slide = {
  titleHtml:
    "If we add some absorption material with α = 0,5 on ceilling<br>the reverberation time and speech intelligibilty is:",
  description: "Select the correct answer.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/12/task/task-2.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
